module.exports = __webpack_public_path__ + "static/media/cancel_right.3b9fa4c1.png";